import { Component } from '@angular/core';
import { ViewController, LoadingController, Events, ModalController } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { AppState } from '../../config/state';
import { PatronProvider } from '../../providers/patron/patron';
import { CoPatronDetailsPage } from '../../pages/co-patron-details/co-patron-details';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { SoundsProvider } from '../../providers/sounds/sounds';

/**
 * Generated class for the CoSignOutPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-sign-out-popover',
  templateUrl: 'co-sign-out-popover.html'
})
export class CoSignOutPopoverComponent {
  logoutLoader: any;
  patronInfo: any;
  constructor(private login : LoginProvider, private viewCtrl : ViewController, private loader : LoadingController, private events : Events, private timeout : TimeoutFunctionsProvider, private state : AppState, private patronProvider : PatronProvider, private modalCtrl: ModalController, private toastAlert: ToastAlertsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
  }

  logout(logout){
    this.sounds.playSoundOnButtonClick();
    if (logout) {
      this.viewCtrl.dismiss({logout : logout}).catch(err=>{});
      this.login.logout();
      this.logoutLoader = this.loader.create({ content: "Logging you out"});
      this.logoutLoader.present();
    }
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  openMyAccount(){
    this.sounds.playSoundOnButtonClick();
    // console.log(this.state)
    let loader = this.loader.create({content: "Getting Account Details"});
    loader.present();
    this.login.getCurrent().then( patron =>{
      this.patronProvider.getFullDetails(patron.barcode).then((res) => {
        if (res && res.id != null) {
          this.patronInfo = res;
          this.patronProvider.getRegisteredForEvents(res.barcode).then(events =>{
            // console.log(res);
            if (events){
              this.patronInfo.events = events;
              // console.log(events, res);
              let modal = this.modalCtrl.create(CoPatronDetailsPage, { patron: this.patronInfo }, {cssClass: 'custom-medium-wide-modal'});
              modal.present();
              loader.dismiss().catch(err=>{});
            } else {
              this.patronInfo.events = [];
              // console.log(events, res);
              let modal = this.modalCtrl.create(CoPatronDetailsPage, { patron: this.patronInfo }, {cssClass: 'custom-medium-wide-modal'});
              modal.present();
              loader.dismiss().catch(err=>{});
              // this.toastAlert.triggerToast('An error occurred, please try again', '');
              // loader.dismiss();
            };
          });
        } else {
          this.toastAlert.triggerToast('An error occurred, please try again', 'Patron Not Found');
          // this.createLibraryCardScannerPopover();
          loader.dismiss().catch(err=>{});
        };
      }).catch((err) => {
        console.log('failed to login');
        loader.dismiss().catch(err=>{});
        this.toastAlert.triggerToast('Incorrect Information', '');
      });
    })
  }

  ionViewDidLeave(){
  //  console.log('we left the building');
  if (this.logoutLoader) this.logoutLoader.dismiss().catch(err=>{});
  }
}



// WEBPACK FOOTER //
// ./src/components/co-sign-out-popover/co-sign-out-popover.ts